import { render, staticRenderFns } from "./accommodationTypes.vue?vue&type=template&id=905ab3c4"
import script from "./accommodationTypes.vue?vue&type=script&lang=js"
export * from "./accommodationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports